import React, { memo } from 'react'
import tw from 'twin.macro'
import { getCurrentCollectDataStep } from 'src/selectors/collectData'
import { getDriver } from 'src/selectors/driver'
import { useSelector } from 'react-redux'
import { DataCollectionSource } from 'src/constants/shared'
import { CollectDataStepIndex } from './CollectDataStepIndex'
import { OptionalStepLabel } from './OptionalStepLabel'

interface StepLabelsProps {
  hideStepIndex?: boolean
}

const StepLabelsComponent = ({ hideStepIndex }: StepLabelsProps) => {
  const currentStep = useSelector(getCurrentCollectDataStep)
  const driver = useSelector(getDriver)

  const isRecollection = driver?.collectDataFlow === DataCollectionSource.Recollection
  const isOptionalStep = currentStep?.optional ?? false
  const shouldHideStepIndex = hideStepIndex || isRecollection

  if (shouldHideStepIndex && !isOptionalStep) {
    return null
  }

  return (
    <div css={tw`flex items-center gap-2 mb-2`}>
      {!shouldHideStepIndex && <CollectDataStepIndex stepId={currentStep?.id} />}
      {isOptionalStep && <OptionalStepLabel />}
    </div>
  )
}

export const StepLabels = memo(StepLabelsComponent)
